import React, { SVGProps } from 'react';

/* eslint-disable max-len */
const SvgCarryingStopSign: React.FunctionComponent<SVGProps<SVGSVGElement>> = props => (
  <svg
    viewBox="0 0 319 324"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <defs>
      <path id="id517867701__a" d="M.22.43h211.93v207.3H.22z" />
      <path
        d="M21.64 52.9c0-5.6 2.75-8.8 8.1-8.8s8.1 3.2 8.1 8.8V54h-5.2v-1.45c0-2.5-1-3.45-2.75-3.45s-2.75.95-2.75 3.45c0 7.2 10.75 8.55 10.75 18.55 0 5.6-2.8 8.8-8.2 8.8-5.4 0-8.2-3.2-8.2-8.8v-2.15h5.2v2.5c0 2.5 1.1 3.4 2.85 3.4s2.85-.9 2.85-3.4c0-7.2-10.75-8.55-10.75-18.55zm19.97-3.4v-5h17v5h-5.75v30h-5.5v-30h-5.75zm26.62 3.05v18.9c0 2.5 1.1 3.45 2.85 3.45s2.85-.95 2.85-3.45v-18.9c0-2.5-1.1-3.45-2.85-3.45s-2.85.95-2.85 3.45zm-5.5 18.55V52.9c0-5.6 2.95-8.8 8.35-8.8 5.4 0 8.35 3.2 8.35 8.8v18.2c0 5.6-2.95 8.8-8.35 8.8-5.4 0-8.35-3.2-8.35-8.8zm30.52-26.6c5.5 0 8.2 3.05 8.2 8.65v4.55c0 5.6-2.7 8.65-8.2 8.65h-2.6V79.5h-5.5v-35h8.1zm0 5h-2.6v11.85h2.6c1.75 0 2.7-.8 2.7-3.3V52.8c0-2.5-.95-3.3-2.7-3.3z"
        id="id517867701__d"
      />
      <filter
        x="-2.5%"
        y="-2.8%"
        width="105%"
        height="111.2%"
        filterUnits="objectBoundingBox"
        id="id517867701__c"
      >
        <feOffset dy={1} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          stdDeviation={0.5}
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.216318837 0"
          in="shadowBlurOuter1"
        />
      </filter>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        d="M235.93 190.71c2.68 16.48-6.49 29.52-19.14 31.28 0 0-10.74-.71-8.22-12.16 0 0-11.85-3.27-7.11-13.5 0 0-12.88-.8-12.22-15.51 0 0 .23-14.1 12-30.23 0 0 9.02-9.49 13.67-5.97 0 0 17.62 25.15 21.02 46.1zM12 146.94s-27.51 67.07.78 71.94c0 0 10.51-.22 7.65-10.98 0 0 11.5-2.57 6.5-12.29 0 0 12.6-.21 11.45-13.94 0 0-.7-13.14-12.79-28.63 0 0-9.15-9.19-13.6-6.1"
        fill="#FF7C1F"
      />
      <g transform="translate(10 56.56)">
        <mask id="id517867701__b" fill="#fff">
          <use xlinkHref="#id517867701__a" />
        </mask>
        <path
          d="M199.96 57.08a124 124 0 0 1-4.54-12.69l-9.1-32.2a5.93 5.93 0 0 0-8.16-3.9l-10.88 4.53c-3.52 1.44-9.06 1.32-12.49-.14 0 0-25.7-11.29-44.13-12.2-19.68-.9-48.21 9.85-48.21 9.85-3.5 1.3-9.13 1.02-12.53-.57l-10.33-4.8a5.88 5.88 0 0 0-8.3 3.57l-10 29.9a114.3 114.3 0 0 1-5.27 12.44S1.24 79.14.32 99.51c-2.44 57.16 42.96 105.5 101.46 108.1 58.38 2.58 107.87-41.73 110.31-98.89 1-21.32-12.13-51.64-12.13-51.64"
          fill="#FF7C1F"
          mask="url(#id517867701__b)"
        />
        <path
          d="M18.91 162.63c18.25 25.9 48.27 43.45 82.87 44.98 35.92 1.59 71.7-19 92-44.98 6.26-8-21.6 30.34-87.45 30.34s-93.82-39.42-87.42-30.34z"
          fill="#E06D17"
          mask="url(#id517867701__b)"
        />
      </g>
      <path
        d="M48.85 138.34a34.39 34.39 0 1 0 67.6 12.61 34.39 34.39 0 0 0-67.6-12.61"
        fill="#CC6918"
      />
      <path
        d="M46.53 142.27a34.39 34.39 0 1 0 67.6 12.62 34.39 34.39 0 0 0-67.6-12.62"
        fill="#FFF"
      />
      <path
        d="M129.85 138.34a34.39 34.39 0 1 0 67.6 12.61 34.39 34.39 0 0 0-67.6-12.61"
        fill="#CC6918"
      />
      <path
        d="M127.53 142.27a34.39 34.39 0 1 0 67.6 12.62 34.39 34.39 0 0 0-67.6-12.62"
        fill="#FFF"
      />
      <g fill="#404040">
        <path d="M103.68 157.61a8.4 8.4 0 0 1-8.65 8.09 8.4 8.4 0 0 1-8.1-8.65 8.4 8.4 0 0 1 8.66-8.09 8.4 8.4 0 0 1 8.09 8.65M154.68 157.61a8.4 8.4 0 0 1-8.65 8.09 8.4 8.4 0 0 1-8.1-8.65 8.4 8.4 0 0 1 8.66-8.09 8.4 8.4 0 0 1 8.09 8.65" />
      </g>
      <path
        d="M142.75 187.33l-21.18-15.99c-9.28 5.16-20.53 13.21-20.53 13.21 1.91 3.4 20.53 13.22 20.53 13.22 1.62-.71 8.68-4.19 21.18-10.44z"
        fill="#9B4F16"
      />
      <path
        d="M121 194.81s-16.67-8.15-20.99-8.81c-.27.36 5.24 6.03 19.99 16.44.72.61.35 2.69 2.1 1.33 8.25-5.63 15.95-13.78 21.95-16.24.22-.25.17-.56 0-.87 0 0-19.76 7.1-23.05 8.15z"
        fill="#EFEFEE"
      />
      <path
        d="M140.48 182.97c.44-.63-7.1-10.8-15.78-14.27-1.18-.49-6.18-.49-7.66 0-6.9 3.06-12.07 7.47-15.5 13.24a47.94 47.94 0 0 0-4.87 5.04c5.8-1.44 2.25 1.74 8.99 0 .43-.11 5.78-1.22 16.05-3.33a233.83 233.83 0 0 1 14.18 3.33c4.42 1.26 9.21 0 10.85 0l-6.26-4z"
        fill="#FFF"
      />
      <path
        d="M292.1 314.14c0-2.58-15.75-5.68-40.68-7.05-24.93-1.36-37.09.68-46.78 0-6.96-.49-71.37-5.09-87.37-5.09C77.91 302 46 307.27 46 314.14c0 6.87 31.91 9.65 71.27 9.65 19.9 0 48.27-4.94 87.37-6.53 12.11-.5 25.2 3.5 46.78 3.3 21.58-.18 40.68-4.1 40.68-6.42z"
        fill="#000"
        fillRule="nonzero"
        opacity={0.28}
      />
      <g fillRule="nonzero">
        <path
          d="M231.61 117.15l12.43 3.8-30.7 100.42c-2.93 2.43-5.83 2.96-8.7 1.6-2.87-1.38-4.11-3.18-3.73-5.4l30.7-100.42z"
          fill="#5A5A5A"
        />
        <path
          fill="#404040"
          d="M234.65 119.07l9.4 1.88-30.7 100.42-7.83-2.4z"
        />
        <path
          fill="#5A5A5A"
          d="M203.52 24l-14.3 47.54 24.31 43 46.77 14.3 43.34-23.28 14.47-47.34-22.9-43.53L248.42.4z"
        />
        <path
          fill="#404040"
          d="M234.02 120.8l26.28 8.04 43.34-23.28 14.47-47.34-22.9-43.53-24.05-7.35z"
        />
        <path
          fill="#FFF"
          d="M207.34 26.09l-13.5 44.17L215.6 111l44 13.46 40.7-21.64 13.5-44.17-21.63-40.7-44-13.45z"
        />
        <path
          fill="#F2F2F2"
          d="M235.39 117.04l24.22 7.4 40.69-21.63 13.5-44.17-21.63-40.7-22.32-6.82z"
        />
        <path
          fill="#FF3652"
          d="M212.06 30.62l-12 39.27 19.35 36.21 39.13 11.97 36.19-19.23 12-39.27-19.24-36.18-39.13-11.96z"
        />
        <g transform="rotate(17 142.8 707.95)">
          <use
            fill="#000"
            filter="url(#id517867701__c)"
            xlinkHref="#id517867701__d"
          />
          <use fill="#FFF" xlinkHref="#id517867701__d" />
        </g>
      </g>
      <path
        fill="#9B4F16"
        d="M157.62 98l2.38 4.09L135.56 114l-1.56-9.34zM86.38 98L84 102.09 108.44 114l1.56-9.34z"
      />
      <path
        d="M235.93 190.71c2.68 16.48-6.49 29.52-19.14 31.28 0 0-10.74-.71-8.22-12.16 0 0-11.85-3.27-7.11-13.5 0 0 12.04-1.7 20.69-5.62 7.78-3.52 12.17-9.92 13.78 0z"
        fill="#FF7C1F"
      />
    </g>
  </svg>
);
/* eslint-enable max-len */

export default SvgCarryingStopSign;
